const SPRITE = '/icons/intro-sprite-v3.svg';

type IntroIconProps = { size?: number };

const SpriteIcon = ({
  id,
  viewBox,
  size
}: {
  id: string;
  viewBox: string;
  size: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    width={size}
    height={size}
    fill="#01686c"
    aria-hidden="true"
  >
    <use href={`${SPRITE}#${id}`} />
  </svg>
);

export const HouseHeartIcon = ({ size = 48 }: IntroIconProps) => (
  <SpriteIcon id="house-heart" viewBox="0.5 0.5 34 34" size={size} />
);

export const TwoWayArrowIcon = ({ size = 48 }: IntroIconProps) => (
  <SpriteIcon id="two-way-arrow" viewBox="0 0 100 100" size={size} />
);

export const PuppyIcon = ({ size = 48 }: IntroIconProps) => (
  <SpriteIcon id="puppy" viewBox="0 0 450 485" size={size} />
);
